import { gql } from "graphql-request";

const SERVER_CREATE_DOCUMENT_TEMPLATE = gql`
  mutation SERVER_CreateDocumentTemplate($input: DocumentTemplateInput!) {
    createDocumentTemplate(input: $input) {
      id
    }
  }
`;
export default SERVER_CREATE_DOCUMENT_TEMPLATE;